import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ABOUT, HELP, INFOPAGE } from '../../../router/routes';
import { RootState } from '../../../store/store';
import { toggleSidebarMenuOpen } from '../../../store/global-slice';
import Hamburger from '../../common/hamburger';
import css from './index.module.css';

export default function Sidebar() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isSidebarMenuOpen } = useSelector((state: RootState) => ({
    isSidebarMenuOpen: state.global.isSidebarMenuOpen,
  }));

  const closeMenu = () => dispatch(toggleSidebarMenuOpen());
  const classNames = `${css['wrapper']} ${
    isSidebarMenuOpen ? css['active'] : ''
  }`;

  return (
    <div className={classNames}>
      <div className={css['bg']} />
      <div className={css['sidebar']}>
        <div className={css['hamburger-wrapper']}>
          <Hamburger theme="light" />
        </div>

        <ul className={css['menu']}>
          <li className={css['menu-item']}>
            <a href={INFOPAGE} onClick={closeMenu}>
              {t('components.external.header.home')}
            </a>
          </li>
          <li className={css['menu-item']}>
            <a href={ABOUT} onClick={closeMenu}>
              {t('components.external.header.about')}
            </a>
          </li>
          <li className={css['menu-item']}>
            <a href={HELP} onClick={closeMenu}>
              {t('components.external.header.help')}
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
